export function snapToStep(value, min, max, step) {
  if (!Number.isFinite(value)) {
    return Number.isFinite(min) ? min : 0;
  }
  if (!Number.isFinite(step) || step === 0) {
    return clampToRange(value, min, max);
  }
  const origin = Number.isFinite(min) ? min : 0;
  const stepped = Math.round((value - origin) / step) * step + origin;
  return clampToRange(stepped, min, max);
}
function clampToRange(value, min, max) {
  let next = value;
  if (Number.isFinite(min)) {
    next = Math.max(min, next);
  }
  if (Number.isFinite(max)) {
    next = Math.min(max, next);
  }
  return next;
}
export function isWithinRange(value, min, max) {
  return value >= min && value <= max;
}
export function isOnStep(value, min, step) {
  const origin = Number.isFinite(min) ? min : 0;
  return Math.abs((value - origin) % step) < Number.EPSILON || Math.abs((value - origin) % step - step) < Number.EPSILON;
}